import React from "react";
import "./acknowledegements.css";

const Acknowledements = () => {
  return (
    <div className="poster-container">
      <div className="poster-content">
        <h1>Coming Soon.....</h1>
        <p className="poster-content-p">
          For Further information, please contact at{" "}
          <a href="mailto:maryam.fatima@sihs.org.pk">
            maryam.fatima@sihs.org.pk
          </a>
        </p>
      </div>
    </div>
  );
};

export default Acknowledements;
